/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing the first 500 characters.`)
};

const es_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando los primeros 500 caracteres.`)
};

const de_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeigt die ersten 500 Zeichen an.`)
};

const nl_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toont de eerste 500 karakters.`)
};

const fr_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage des 500 premiers caractères.`)
};

const it_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra i primi 500 caratteri.`)
};

const pt_br2_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando os primeiros 500 caracteres.`)
};

const pt_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando os primeiros 500 caracteres.`)
};

const ja_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「最初の 500 文字を表示しています。」`)
};

const zh_ci_truncated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示前 500 个字符。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_truncated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_truncated(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_truncated", locale)
	if (locale === "en") return en_ci_truncated(inputs)
	if (locale === "es") return es_ci_truncated(inputs)
	if (locale === "de") return de_ci_truncated(inputs)
	if (locale === "nl") return nl_ci_truncated(inputs)
	if (locale === "fr") return fr_ci_truncated(inputs)
	if (locale === "it") return it_ci_truncated(inputs)
	if (locale === "pt-BR") return pt_br2_ci_truncated(inputs)
	if (locale === "pt") return pt_ci_truncated(inputs)
	if (locale === "ja") return ja_ci_truncated(inputs)
	return zh_ci_truncated(inputs)
};